import { isAxiosError } from "axios";
import { useTranslation } from "react-i18next";
import { css } from "../../../../styled-system/css";
import { VStack } from "../../../../styled-system/jsx";
import { DevErrorDisplay } from "../../../components/core/blocks/DevErrorDisplay";

interface Props {
  error?: unknown;
}

export const PricingProductUnavailable = ({ error }: Props) => {
  const { t } = useTranslation(["pricingv2"]);
  const isMissing = !error || (isAxiosError(error) && error.response?.status === 404);

  return (
    <VStack
      width="100%"
      paddingY="48px"
      paddingX="medium"
      alignItems={isMissing ? "center" : "flex-start"}
      justifyContent="center"
    >
      {isMissing ?
        <span className={css({ fontSize: "xxlarge", fontWeight: "bold", textAlign: "center" })}>
          {t(($) => $.pricingv2["Product Not Enrolled in Pricing"])}
        </span>
      : <DevErrorDisplay error={error} userMessage={t(($) => $.pricingv2["Failed to load pricing data."])} />}
    </VStack>
  );
};
